<template>

    <div class="main-price">
        <span class="new-price">
            {{ price }} {{ currency }} </span>
        <span v-if="hasDiscount" class="old-price">{{ mainPrice }} {{ currency }}</span>
        
    </div>
    <span class="without-tax">{{ priceWithoutTax }} {{ currency }} bez DPH</span>

</template>

<script>
import { defineComponent, onMounted, reactive, toRefs } from 'vue'

import emitter from '../../../utils/emitter'

export default defineComponent({

    props: [
        'hasDiscount',
        'mainPrice',
        'discountPrice',
        'price',
        'priceWithoutTax',
        'currency'
    ],

    setup(props) {

        const state = reactive({
            hasDiscount: props.hasDiscount,
            discountPrice: props.discountPrice,
            price: props.price,
            priceWithoutTax: props.priceWithoutTax,
        })

        onMounted( () => {

            emitter.on('variationChange', (data) => {
                state.hasDiscount     = data.has_discount_price
                state.discountPrice   = `${data.discount_price} ${props.currency}`
                state.price           = `${data.price} ${props.currency}`
                state.priceWithoutTax = `${data.price_without_tax} ${props.currency}`
            })
        })

        return {
            ...toRefs(state)
        }
    }
})
</script>
